import { apiFetch } from './client';

export type EntityType =
  | 'recordings' | 'folders' | 'ivr_trees' | 'ivr_nodes' | 'time_frames'
  | 'voicemail_boxes' | 'conferences' | 'surveys_quizzes' | 'auth_lists'
  | 'auth_list_entries' | 'callers' | 'phone_numbers' | 'payments'
  | 'customers' | 'resellers';

export const ALL_ENTITY_TYPES: readonly EntityType[] = [
  'recordings', 'folders', 'ivr_trees', 'ivr_nodes', 'time_frames',
  'voicemail_boxes', 'conferences', 'surveys_quizzes', 'auth_lists',
  'auth_list_entries', 'callers', 'phone_numbers', 'payments',
  'customers', 'resellers',
] as const;

export interface SearchRow {
  id: string;
  ref_number: string;
  ref_label: string;
  name: string;
  snippet?: string;
  url: string;
  customer_id?: string;
  customer_name?: string;
  extra?: Record<string, unknown>;
}

export interface SearchGroup {
  rows: SearchRow[];
  total: number;
}

export interface SearchResponse {
  groups: Partial<Record<EntityType, SearchGroup>>;
  scoped_to_customer_id: string | null;
  took_ms: number;
}

export interface SearchParams {
  q: string;
  types?: EntityType[];
  customer_id?: string;
  date_from?: string;
  date_to?: string;
  include_inactive?: boolean;
  include_deleted?: boolean;
  per_group_limit?: number;
}

export const search = {
  run: (p: SearchParams) => {
    const q = new URLSearchParams();
    q.set('q', p.q);
    if (p.types && p.types.length > 0) q.set('types', p.types.join(','));
    if (p.customer_id) q.set('customer_id', p.customer_id);
    if (p.date_from) q.set('date_from', p.date_from);
    if (p.date_to) q.set('date_to', p.date_to);
    if (p.include_inactive) q.set('include_inactive', '1');
    if (p.include_deleted) q.set('include_deleted', '1');
    if (p.per_group_limit) q.set('per_group_limit', String(p.per_group_limit));
    return apiFetch<SearchResponse>(`/api/search?${q.toString()}`);
  },
};
